module.exports = {"id":"212692","name":"Rony Lopes","rating":"78","photo":"./data/images/photos/4/212692.png","club":{"name":"AS Monaco","logo":"./data/images/clubs/ASMonaco.png"},"positions":["MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RonyLopes0.json
// module id = 3717
// module chunks = 0